import React from "react";
import { Avatar } from "@mui/material";
import { advisoryCommittee } from "../data/members";

const AdvisoryTeam = () => {
  return (
    <div className="flex flex-col items-stretch"> {/* Adjusted for center alignment */}
      {[...advisoryCommittee].map(({ name, avatar, title, url, position }, index) => {
        return (
          <div className="flex flex-row items-center gap-4 my-4" key={`advisory-committee-${index}`}> {/* Center alignment adjustments */}
            <Avatar 
              src={avatar} 
              alt={name}
              style={{ width: "120px", height: "120px" }} // Increased size
            />
            <div className="text-left"> {/* Center text alignment */}
              {url ? (
                <a href={url} rel="noreferrer" target="_blank" className="hover:underline">
                  <p className="text-lg font-semibold">
                    <span className="font-normal italic">{title}.</span>
                    &nbsp;{name}
                  </p>
                </a>
              ) : (
                <p className="text-lg font-semibold">
                  <span className="font-normal italic">{title}.</span>
                  &nbsp;{name}
                </p>
              )}
              <p className="text-semibold text-blue-950">
                {position}
              </p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AdvisoryTeam;